import { render, staticRenderFns } from "./ModalContaServico.vue?vue&type=template&id=08ac7c12&scoped=true"
import script from "./ModalContaServico.vue?vue&type=script&lang=js"
export * from "./ModalContaServico.vue?vue&type=script&lang=js"
import style0 from "./ModalContaServico.vue?vue&type=style&index=0&id=08ac7c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac7c12",
  null
  
)

export default component.exports